import boletaApi from "./boletaApi";

export const getUsers = () => boletaApi.get("/allusers");

export const createUser = (data) => boletaApi.post("/createNewUser", data);

export const updateUser = (data) => boletaApi.post("/updateUser", data);

export const deleteUser = (data) => boletaApi.post("/deleteUser", data);
